import React from 'react';
import { Typography } from '~/UIKit';
import { FITOGRAM_BLUE_FADED_9, ICON_WARING } from '~/Constants/Colors.constants';
import { FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { WarningRounded } from '@mui/icons-material';
import { makeStyles } from '~/UIKit/Style';
import { useItemCreationContext } from '../ItemCreation';

const useStyles = makeStyles(
  () => ({
    root: {
      background: FITOGRAM_BLUE_FADED_9,
      fontSize: FONT_SIZE_SMALLISH,
      margin: '10px 0',
      padding: 10,
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginRight: 10,
      color: ICON_WARING,
    },
  }),
  { name: 'ItemCreationError' },
);

export const ItemCreationErrors = () => {
  const { classes } = useStyles();
  const { errors, touched } = useItemCreationContext();
  const ErrorEntries = Object.entries((errors as object) || {}).filter(
    (error) => !!error[1] && !!touched[error[0]],
  );

  if (!ErrorEntries.length) {
    return null;
  }

  return (
    <div className={classes.root}>
      <WarningRounded className={classes.icon} />
      <div>
        {ErrorEntries.map(([key, value]) => (
          <Typography
            variant="body2"
            key={key}
            dangerouslySetInnerHTML={{ __html: String(value) }}
          />
        ))}
      </div>
    </div>
  );
};
